import React,{useEffect } from 'react'
import { animation, headerReset,showNavLink } from "../Helper/CssHelper";

function Home() {

  useEffect(() => {
    headerReset("Justin Dsouza");
    showNavLink('home','home-section');
    animation("home-section");
  }, []);
  return (
    <div>
      <section id="home-section" className="home section-show">
        {/* This Is Purposefully Left Empty 
            the Home Page is Expanded Header */}
      </section>
    </div>
  );
}

export default Home;
